module.exports = __webpack_public_path__ + "static/media/thum_no_image.64c9d333.svg";